import { CurrencyPipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RevenueComponent, RevenuePeriod } from '@vendasta/sales-orders';

interface PeriodOptions {
  label: string;
  value: RevenuePeriod;
}

@Component({
  selector: 'sales-ui-sales-order-edit-price',
  templateUrl: './sales-order-edit-price.component.html',
  styleUrls: ['./sales-order-edit-price.component.scss'],
})
export class SalesOrderEditPriceComponent implements OnInit {
  @ViewChild('input', { static: true }) input: ElementRef;
  @Input() revenueComponent: RevenueComponent;
  @Input() allowDelete: boolean;
  @Input() currencyCode: string;
  @Input() form: UntypedFormGroup;
  @Input() allowNegativeValues = false;
  @Input() canEditPeriod = true;
  @Output() errorMessage: EventEmitter<string> = new EventEmitter();

  @Output() delete: EventEmitter<RevenueComponent> = new EventEmitter();

  currencySymbol: string;

  periodOptions: PeriodOptions[] = [
    { label: 'FRONTEND.STORE.PERIODS.ONE_TIME', value: RevenuePeriod.ONETIME },
    { label: 'FRONTEND.STORE.PERIODS.MONTHLY', value: RevenuePeriod.MONTHLY },
    { label: 'FRONTEND.STORE.PERIODS.YEARLY', value: RevenuePeriod.YEARLY },
  ];

  oneTimeOnly: PeriodOptions[] = [{ label: 'FRONTEND.STORE.PERIODS.ONE_TIME', value: RevenuePeriod.ONETIME }];

  constructor(private readonly formatCurrencyPipe: CurrencyPipe) {}

  ngOnInit(): void {
    this.currencySymbol = this.formatCurrencyPipe.transform(0, this.currencyCode, 'symbol-narrow').charAt(0);
  }

  handleDelete(): void {
    this.delete.emit(this.revenueComponent);
  }

  markAsTouched(): void {
    this.form.markAsTouched();
    this.form.updateValueAndValidity();
    for (const i in this.form.controls) {
      if (i) {
        this.form.controls[i].updateValueAndValidity();
        this.form.controls[i].markAsTouched();
      }
    }
  }
}
